var map = {
	"./cs.png": 2081,
	"./cs2.jpg": 7799,
	"./deutsch.png": 7011,
	"./devops.jpg": 268,
	"./linux.jpg": 7441,
	"./network+.jpg": 2314,
	"./sae.jpg": 9570,
	"./sql.jpg": 247,
	"./sysadmin.jpg": 4787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8881;